import React from 'react';
import PageHeader from '../../components/PageHeader';

type Props = {
  title: string;
};

export const EngagementContainer: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  children,
}) => {
  return (
    <>
      <PageHeader title={title} />
      {children}
    </>
  );
};
